var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "responsiveIframe" } }, [
    _c(
      "div",
      { attrs: { id: "responsiveIframeSlot" } },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c("iframe", {
      style: "width:100%;height:" + _vm.height,
      attrs: { src: _vm.src },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }